module.exports = __webpack_public_path__ + "static/media/0_2020_01_22.9387ef95.jpg";